if (!customElements.get('size-guide-modal')) {
  customElements.define(
    'size-guide-modal',
    class SizeGuideModal extends ModalComponent {
      get isLockingNeeded() {
        return true;
      }

      get requiresBodyAppended() {
        return true;
      }

      connectedCallback() {
        super.connectedCallback();

        this.addEventListener(
          'click',
          (event) => {
            const tab = event.target.closest('[data-size-guide-tab]');

            if (tab) this.select(tab);
          },
          { signal: this.abortController.signal }
        );

        // The CSS fallback derives the badge width from the column count, which
        // is off by a fraction of a pixel whenever a column width is fractional.
        // Measuring the rendered column is the only way to land on it exactly.
        this.resizeObserver = new ResizeObserver(() => this.syncBadgeWidths());
        this.querySelectorAll('.size-guide__table').forEach((table) => this.resizeObserver.observe(table));
      }

      disconnectedCallback() {
        super.disconnectedCallback();

        this.resizeObserver?.disconnect();
      }

      handleAfterShow() {
        super.handleAfterShow();

        // Until this point the badge keeps its CSS width. Measuring earlier
        // catches a mid-animation layout and the correction is visible as a jump.
        this.isShown = true;
        this.syncBadgeWidths();
      }

      handleAfterHide() {
        super.handleAfterHide();

        this.isShown = false;
      }

      syncBadgeWidths() {
        if (!this.isShown) return;

        this.querySelectorAll('.size-guide__panel').forEach((panel) => {
          const badge = panel.querySelector('.size-guide__badge');
          const cell = panel.querySelector('tbody td:first-child');

          if (!badge || !cell) return;

          // the painted tile is the cell minus the collapsed border it shares
          const border = parseFloat(getComputedStyle(cell).borderRightWidth) || 0;
          const tile = cell.getBoundingClientRect().width - border;

          badge.style.minWidth = tile > 0 ? `${tile}px` : '';
        });
      }

      select(tab) {
        let selectedPanel = null;

        this.querySelectorAll('[data-size-guide-tab]').forEach((el) => {
          const isSelected = el === tab;
          // Scoped to this modal: the snippet also renders inside quick view, so ids repeat.
          const panel = this.querySelector(`[id="${el.getAttribute('aria-controls')}"]`);

          el.setAttribute('aria-pressed', isSelected);
          if (panel) {
            panel.hidden = !isSelected;
            if (isSelected) selectedPanel = panel;
          }
        });

        // Only the how-to-measure diagram scrolls itself into view; switching
        // fits leaves the scroll position alone.
        if (tab.hasAttribute('data-size-guide-scroll')) {
          selectedPanel?.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'nearest',
          });
        }
      }
    }
  );
}
